var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.filterValues && this.filterValues.length
    ? _c(
        "span",
        _vm._l(_vm.getFilterValues(), function (v, index) {
          return _c(
            "span",
            { key: index, staticClass: "badge badge-pill bg-light me-1" },
            [
              _vm._v("\n  " + _vm._s(_vm.displayValue(v)) + "\n  "),
              _c(
                "a",
                {
                  staticClass: "text-decoration-none",
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("delete", v)
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-times-circle" })]
              ),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }